import { render, staticRenderFns } from "./calcularFrete.vue?vue&type=template&id=4f86f6b6"
import script from "./calcularFrete.ts?vue&type=script&lang=js&external"
export * from "./calcularFrete.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f86f6b6')) {
      api.createRecord('4f86f6b6', component.options)
    } else {
      api.reload('4f86f6b6', component.options)
    }
    module.hot.accept("./calcularFrete.vue?vue&type=template&id=4f86f6b6", function () {
      api.rerender('4f86f6b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/calcularFrete.vue"
export default component.exports